import styled from 'styled-components';
import {
  Input, Icon, Radio, Checkbox,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { platformType } from '../../utils/platform-type';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background-color: #fff;
  margin: 20px 0px 20px 0px;
  ${platformType !== 'company' && 'border: 1px solid #cad3db;'}
`;

export const RadioInput = styled(Radio)`
  margin-right: 5px;
`;

export const BoxSelect = styled.div`
  width: 100%;
  max-width: 378px;
  flex-direction: column;
  display: flex;
  align-items: center;
  margin: 20px 0px 20px 0px;

  /* @media (min-width: 981px) and (max-width: 1199px) {
  }

  @media (min-width: 768px) and (max-width: 980px) {
  }   */

  @media (min-width: 480px) and (max-width: 767px) {
    padding: 10px;
    margin: 0px;
  }

  @media (min-width: 320px) and (max-width: 479px) {
    padding: 10px;
    margin: 0px;
  }
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: scroll;
  border-radius: 3px;
  padding: 10px;
  height: 180px;
  max-height: 180px;
`;

export const BoxItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${(props) => (props.error ? props.theme.color.error : '#CAD3DB')};
  padding: 10px;
`;

export const BoxSearch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
    cursor: pointer;

    @media (min-width: 480px) and (max-width: 767px) {
      margin-left: 10px;
    }
    @media (min-width: 320px) and (max-width: 479px) {
      margin-left: 10px;
    }
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const InputFind = styled(Input)`
  width: 80%;
  height: 35px;
  padding: 10px;
  background-color: #F1F1F2;
  border-radius: 30px;
  border: none;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
  word-wrap: break-word;
  outline: none;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    background: transparent !important;
    border: 0 !important;
  }
`;

export const ErrorMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  span {
    color: ${(props) => props.theme.color.textError};
    font-weight: 500;
    font-size: 0.75rem;
  }
`;

export const Options = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  flex-shrink: 0;
  cursor: pointer;

  span {
    color: ${(props) => props.theme.color.text};
    font-size: 16px;
    font-weight: 500;
  }
`;

export const Items = styled.div`
  color: ${(props) => props.theme.color.text};
  font-size: 16px;
  font-weight: 500;
`;

export const SubItems = styled.div`
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media (min-width: 480px) and (max-width: 767px) {
    margin: 7px 0px 7px 15px;
  }
  @media (min-width: 320px) and (max-width: 479px) {
    margin: 7px 0px 7px 15px;
  }
`;

export const CheckboxInput = styled(Checkbox)`
  margin-right: 5px;
`;

export const IconItem = styled(Icon)`
  background-color: #12213f;
  border-radius: 10px;
  width: 20px !important;
  height: 20px !important;
  margin-left: 5px !important;
  cursor: pointer;
`;

export const BoxItemsSelected = styled.div`
  margin-top: 40px;
  display: flex;
  width: 100%;
  flex-direction: column;

  .item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    span {
      display:flex;
      flex-direction:row;
      align-items:center;
      justify-content:center;
      background-color: #1b315d;
      color: #fff;
      font-size: 10px;
      font-weight: 500;
      border-radius: 30px;
      margin-right: 10px;
      padding: 4px 10px 4px 10px;
      margin-top:5px;
    }
  }

`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LinkItem = styled.a`
  margin: 0px 8px;
`;
